import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";

const READ_KEY = "nl-read-count";
const DONE_KEY = "nl-tg-prompt-done";

export const TelegramPrompt = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const counted = useRef<string | null>(null);

  useEffect(() => {
    if (!location.pathname.startsWith("/article/")) return;
    if (localStorage.getItem(DONE_KEY)) return;
    if (counted.current !== location.pathname) {
      counted.current = location.pathname;
      localStorage.setItem(READ_KEY, String(Number(localStorage.getItem(READ_KEY) || 0) + 1));
    }
    if (Number(localStorage.getItem(READ_KEY) || 0) >= 2) {
      const t = setTimeout(() => {
        if (!(window as any).__nl_email_popup) setShow(true);
      }, 4000);
      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  const done = () => {
    localStorage.setItem(DONE_KEY, "1");
    setShow(false);
  };

  if (!show || location.pathname.startsWith("/admin")) return null;

  return (
    <div data-testid="telegram-prompt"
      className="fixed z-[80] inset-x-3 bottom-3 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:w-[380px] bg-[#121212] border border-[#00E5FF]/40 rounded-xl shadow-2xl shadow-black/60 p-4 animate-in slide-in-from-bottom-4 fade-in duration-300">
      <button onClick={done} data-testid="telegram-prompt-dismiss"
        className="absolute top-2.5 right-2.5 text-gray-500 hover:text-white transition-colors">
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#229ED9]/15 border border-[#229ED9]/40 flex items-center justify-center shrink-0">
          <svg viewBox="0 0 24 24" className="h-5 w-5 fill-[#229ED9]" aria-hidden="true">
            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
          </svg>
        </div>
        <div className="min-w-0 pr-4">
          <p className="font-heading font-bold text-white text-sm">Enjoying NewsLayer?</p>
          <p className="text-gray-400 text-xs mt-1 leading-relaxed">
            Get breaking crypto stories the second they drop — join our Telegram channel.
          </p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <a href="https://t.me/newslayerapp" target="_blank" rel="noreferrer" onClick={done}
          data-testid="telegram-prompt-join"
          className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#229ED9] text-white font-bold text-sm rounded-md py-2 hover:bg-[#1d8bbf] transition-colors">
          Join the Channel
        </a>
        <button onClick={done} data-testid="telegram-prompt-later"
          className="px-4 text-sm text-gray-400 hover:text-white transition-colors">
          No thanks
        </button>
      </div>
    </div>
  );
};
